/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { keysCreate } from "../funcs/keysCreate.js";
import { keysList } from "../funcs/keysList.js";
import { keysRevokeById } from "../funcs/keysRevokeById.js";
import { keysRotate } from "../funcs/keysRotate.js";
import { keysValidate } from "../funcs/keysValidate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { Key } from "../models/components/key.js";
import { ListKeysResult } from "../models/components/listkeysresult.js";
import { ValidateKeyResult } from "../models/components/validatekeyresult.js";
import {
  CreateAPIKeyRequest,
  CreateAPIKeySecurity,
} from "../models/operations/createapikey.js";
import {
  ListAPIKeysRequest,
  ListAPIKeysSecurity,
} from "../models/operations/listapikeys.js";
import {
  RevokeAPIKeyRequest,
  RevokeAPIKeySecurity,
} from "../models/operations/revokeapikey.js";
import {
  RotateAPIKeyRequest,
  RotateAPIKeySecurity,
} from "../models/operations/rotateapikey.js";
import {
  ValidateAPIKeyRequest,
  ValidateAPIKeySecurity,
} from "../models/operations/validateapikey.js";
import { unwrapAsync } from "../types/fp.js";

export class Keys extends ClientSDK {
  /**
   * createKey keys
   *
   * @remarks
   * Create a new api key
   */
  async create(
    request: CreateAPIKeyRequest,
    security?: CreateAPIKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<Key> {
    return unwrapAsync(keysCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listKeys keys
   *
   * @remarks
   * List all api keys for an organization
   */
  async list(
    request?: ListAPIKeysRequest | undefined,
    security?: ListAPIKeysSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListKeysResult> {
    return unwrapAsync(keysList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revokeKey keys
   *
   * @remarks
   * Revoke a api key
   */
  async revokeById(
    request: RevokeAPIKeyRequest,
    security?: RevokeAPIKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(keysRevokeById(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * rotateKey keys
   *
   * @remarks
   * Rotate an API key. Agent-key rotation replaces immutable delegation and directly revokes the old row.
   */
  async rotate(
    request: RotateAPIKeyRequest,
    security?: RotateAPIKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<Key> {
    return unwrapAsync(keysRotate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * verifyKey keys
   *
   * @remarks
   * Verify an api key
   */
  async validate(
    request?: ValidateAPIKeyRequest | undefined,
    security?: ValidateAPIKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<ValidateKeyResult> {
    return unwrapAsync(keysValidate(
      this,
      request,
      security,
      options,
    ));
  }
}
